export const LogStatus = {
  "21": "รหัสแอพไม่ถูกต้อง",
  "22": "check digit ไม่ถูกต้อง",
  "23": "รูปแบบ qr code ไม่ถูกต้อว",
  "24": "ถอดรหัสไม่ได้",
  "25": "รูปแบบ product + serial ไม่ถูกต้อง",
  "31": "ไม่พบรหัสบริษัท",
  "32": "ไม่พบรหัสสินค้า",
  "33": "ไม่พบหมายเลขสินค้า"
};

export enum FormState {
  MANDATORY = "M",
  OPTIONAL = "O",
  NOPE = "N"
}
